import BackendConnector from './backendConnector';

export default class EmployerRepHttpService {
    static getEmployerRep(employerRepId) {
        return BackendConnector.get(`/employerRep/${employerRepId}`);
    }

    static getEmployerRepDetails(employerRepId) {
        return BackendConnector.get(`/employerRep/${employerRepId}/details`);
    }

    static getEmployerRepByInvitationId(invitationId) {
        return BackendConnector.get(`/employerRep/byInvitation/${invitationId}`);
    }

    static updateEmployerRep(employerRep) {
        return BackendConnector.put(`/employerRep/${employerRep._id}`, employerRep);
    }

    static removeEmployerReps(employerRepIds, isTestMode = true) {
        return BackendConnector.post('/employerReps/remove', { employerRepIds, isTestMode });
    }

    static getEmployerRepsByIds(employerRepIDs, projection) {
        return BackendConnector.post('/employerRep/search', { employerRepIDs, projection });
    }

    static getEmployerRepsByEmployerId(employerId, projection = []) {
        return BackendConnector.post('/employerRep/search', { employerId, projection });
    }

    static getEmployerRepsByResellerEmployerId(employerId, projection = []) {
        return BackendConnector.post('/employerRep/search', { resellerEmployerId: employerId, projection });
    }

    static getEmployerRepBalance(employerRepId) {
        return BackendConnector.get(`/employerRep/${employerRepId}/creditBalance`);
    }

    static getEmployerRepsByEmail(email, skipAuthError, returnArray, includeUnavailable) {
        return BackendConnector.post('/employerRep/searchByEmail', { email, returnArray, includeUnavailable }, skipAuthError ? { handleAuthError: false } : {});
    }

    static updateEmployerRepRoles(employerRepId, rolesActions) {
        const roles = { add: [rolesActions.add], remove: [rolesActions.remove] };
        return BackendConnector.put(`/employerRep/${employerRepId}/roles`, roles);
    }

    static updateEmployerRepsRoles(employerRepIds, rolesActions, isTestMode = true) {
        const roles = { add: [rolesActions.add], remove: [rolesActions.remove] };
        return BackendConnector.post('/employerReps/roles', { employerRepIds, roles, isTestMode });
    }

    static deactivateExistingEmployerRep(employerRepId, data) {
        return BackendConnector.put(`/employerRep/${employerRepId}/deactivate`, data);
    }

    static deactivateEmployerReps(employerRepIds, isTestMode = true) {
        return BackendConnector.post('/employerReps/deactivate', { employerRepIds, isTestMode });
    }

    static activateExistingEmployerRep(employerRepId, data) {
        return BackendConnector.put(`/employerRep/${employerRepId}/activate`, data);
    }

    static activateEmployerReps(employerRepIds, isTestMode = true) {
        return BackendConnector.post('/employerReps/activate', { employerRepIds, isTestMode });
    }

    static sendInvitationToEmployerRep({
        from, selectedTemplateName, linkText, employerRepId,
    }) {
        return BackendConnector.post('employerRep/sendInvitation', {
            from, selectedTemplateName, linkText, employerRepId,
        });
    }

    static systemSignUp(data) {
        return BackendConnector.post('/employerRep/systemSignUp', data);
    }

    static addToSystem(employerRepId, data) {
        return BackendConnector.post(`/employerRep/${employerRepId}/addToSystem`, data, { returnErrMsg: true });
    }

    static createEmployerRep(data) {
        return BackendConnector.post('employerRep', data);
    }
}
